// extracted by mini-css-extract-plugin
export default {"container":"PUdArx","containerContent":"Nvfuqz"};